// redes-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "30 (padrão)": "30 (predeterminado)",
    "Aceitar vendas externas": "Aceptar ventas externas",
    "AdMob App ID (Android)": "AdMob App ID (Android)",
    "AdMob App ID (iOS)": "AdMob App ID (iOS)",
    "AdMob MREC Unit ID (Android)": "AdMob MREC Unit ID (Android)",
    "AdMob MREC Unit ID (iOS)": "AdMob MREC Unit ID (iOS)",
    "AdMob Native Unit ID (Android)": "AdMob Native Unit ID (Android)",
    "AdMob Native Unit ID (iOS)": "AdMob Native Unit ID (iOS)",
    "Ads Pagos (AdMob) — Build-time": "Ads Pagados (AdMob) — Build-time",
    "Ads Pagos (AdMob) — Runtime": "Ads Pagados (AdMob) — Runtime",
    "Agente de WhatsApp": "Agente de WhatsApp",
    "Análise de Comentários": "Análisis de Comentarios",
    "Análise de Comentários por IA": "Análisis de Comentarios por IA",
    "Análise iniciada. Os resultados aparecerão em breve.": "Análisis iniciado. Los resultados aparecerán pronto.",
    "Análise já está em andamento. Aguarde e tente novamente.": "El análisis ya está en curso. Espere e intente nuevamente.",
    "App Store (iOS)": "App Store (iOS)",
    "AppLovin SDK Key": "AppLovin SDK Key",
    "Atenção:": "Atención:",
    "Ativa": "Activa",
    "Atualizar os fatores pelo grupo": "Actualizar los factores por grupo",
    "Atualização Forçada do App": "Actualización Forzada de la Aplicación",
    "Baixar SVG": "Descargar SVG",
    "Banco do Brasil PIX": "Banco do Brasil PIX",
    "Bolão da Copa": "Quiniela de la Copa",
    "Build Mínimo do App": "Build Mínimo de la Aplicación",
    "Cache do app regenerado.": "Caché de la aplicación regenerado.",
    "Cadastrar nova rede": "Registrar nueva red",
    "Certificado A1 (.pfx)": "Certificado A1 (.pfx)",
    "Client ID": "Client ID",
    "Client Secret": "Client Secret",
    "Clube Certo": "Club Certo",
    "Conferir localização (desativação temporária)": "Verificar ubicación (desactivación temporal)",
    "Conferir localização no abastecimento": "Verificar ubicación en la carga de combustible",
    "Conferir localização no abastecimento (desativação temporária de 15 minutos)": "Verificar ubicación en la carga de combustible (desactivación temporal de 15 minutos)",
    "Configurar o build mínimo irá impactar imediatamente todos os usuários do app que estiverem com uma versão inferior. Eles verão uma tela solicitando atualização.": "Configurar el build mínimo impactará inmediatamente a todos los usuarios de la aplicación que tengan una versión inferior. Verán una pantalla solicitando actualización.",
    "Cor da fonte na Home": "Color de la fuente en el Inicio",
    "Cor do botão de Cadastro": "Color del botón de Registro",
    "Cor do botão de Login": "Color del botón de Login",
    "Cor principal": "Color principal",
    "Cria uma etiqueta por grupo desta rede e leva junto o que tu marcar abaixo. É aditivo: os grupos atuais continuam funcionando do jeito que estão.": "Crea una etiqueta por grupo de esta red y lleva también lo que usted marque a continuación. Es aditivo: los grupos actuales siguen funcionando como están.",
    "Código 2FA": "Código 2FA",
    "Código 2FA habilitado": "Código 2FA habilitado",
    "Código da Rede": "Código de la Red",
    "Degustação até": "Degustación hasta",
    "Deixar vazio para acesso permanente": "Dejar vacío para acceso permanente",
    "Depende de acordo com a InCharge e das estações cadastradas para os postos da rede.": "Depende del acuerdo con InCharge y de las estaciones de carga registradas para las estaciones de servicio de la red.",
    "Descontos que hoje miram o grupo": "Descuentos que hoy apuntan al grupo",
    "Developer App Key": "Developer App Key",
    "Editar rede": "Editar red",
    "Email": "Email",
    "Email para Avisos": "Email para Avisos",
    "Enviar código de verificação por SMS/WhatsApp": "Enviar código de verificación por SMS/WhatsApp",
    "Enviar vendas para Dotz": "Enviar ventas a Dotz",
    "Erro ao atualizar.": "Error al actualizar.",
    "Erro ao carregar a versão da loja.": "Error al cargar la versión de la tienda.",
    "Erro ao iniciar a análise.": "Error al iniciar el análisis.",
    "Facebook": "Facebook",
    "Facebook - Id da página": "Facebook - Id de la página",
    "Fator Dotz": "Factor Dotz",
    "Fator de conversão": "Factor de conversión",
    "Forçar atualização (bloquear app)": "Forzar actualización (bloquear aplicación)",
    "Forçar atualização do cache do app": "Forzar actualización del caché de la aplicación",
    "Habilitado": "Habilitado",
    "Habilitar Ads Pagos": "Habilitar Ads Pagados",
    "Habilitar Roleta da Sorte (app mostra a roleta e o admin libera o cadastro)": "Habilitar Ruleta de la Suerte (la aplicación muestra la ruleta y el panel habilita el registro)",
    "Habilitar SGA": "Habilitar SGA",
    "Habilitar acréscimo": "Habilitar recargo",
    "Habilitar bolão (mobile mostra cards e admin libera abas)": "Habilitar quiniela (el móvil muestra tarjetas y el panel habilita pestañas)",
    "Habilitar código temporário no app": "Habilitar código temporal en la aplicación",
    "Habilitar código temporário no app (Código 2FA)": "Habilitar código temporal en la aplicación (Código 2FA)",
    "Habilitar descontos múltiplos": "Habilitar descuentos múltiples",
    "Habilitar leitura do QR do carregador elétrico no app": "Habilitar lectura del QR del cargador eléctrico en la aplicación",
    "Habilitar recuperação de clientes": "Habilitar recuperación de clientes",
    "Histórico": "Historial",
    "ID do Aplicativo na Apple": "ID de la Aplicación en Apple",
    "Id": "Id",
    "Id copiado para clipboard": "Id copiado al portapapeles",
    "Id do Projeto no Firebase": "Id del Proyecto en Firebase",
    "Identificação": "Identificación",
    "Identificação nas Lojas": "Identificación en las Tiendas",
    "Inativa": "Inactiva",
    "Instagram": "Instagram",
    "Integrações": "Integraciones",
    "Inteligência Artificial": "Inteligencia Artificial",
    "Largura da logo na tela Inicial": "Ancho del logo en la pantalla de Inicio",
    "Layout": "Layout",
    "Libera a tela \"Números de WhatsApp\" para esta rede. Só depois de habilitar aqui é que a rede consegue cadastrar números.": "Habilita la pantalla \"Números de WhatsApp\" para esta red. Solo después de habilitarlo aquí la red podrá registrar números.",
    "Ligar \"usar novas regras de pontuação\" nesta rede": "Activar \"usar nuevas reglas de puntuación\" en esta red",
    "Limites de Pontuação": "Límites de Puntuación",
    "Link": "Link",
    "Link copiado para clipboard": "Link copiado al portapapeles",
    "Logo": "Logo",
    "Membros do grupo → etiqueta": "Miembros del grupo → etiqueta",
    "Meta AN Display Name": "Meta AN Display Name",
    "Meta Audience Network App ID": "Meta Audience Network App ID",
    "Migrar grupos pra etiqueta": "Migrar grupos a etiqueta",
    "Mostrar mensagem Bem Vindo": "Mostrar mensaje de Bienvenida",
    "Mudanças exigem rebuild do app via wl-script": "Los cambios requieren rebuild de la aplicación vía wl-script",
    "Mudanças surtem efeito no próximo carregamento do app": "Los cambios surten efecto en la próxima carga de la aplicación",
    "Módulos": "Módulos",
    "Nome Interno": "Nombre Interno",
    "Nome da rede/posto": "Nombre de la red/estación",
    "Nome de Usuário": "Nombre de Usuario",
    "Nome do Pacote na Apple": "Nombre del Paquete en Apple",
    "Nome do Pacote no Google": "Nombre del Paquete en Google",
    "Nome na Loja": "Nombre en la Tienda",
    "Nome Ícone (Padrão)": "Nombre Ícono (Predeterminado)",
    "Número do build mínimo exigido para usar o app. Usuários com build inferior verão uma tela de atualização.": "Número del build mínimo exigido para usar la aplicación. Los usuarios con build inferior verán una pantalla de actualización.",
    "O que migrar": "Qué migrar",
    "Obrigar a informar bico": "Exigir informar el pico",
    "Obrigar a informar encerrante": "Exigir informar el totalizador",
    "Os números abaixo são o que o cliente consegue baixar agora. Versão enviada e ainda em análise aparece destacada, separada da que está no ar.": "Los números a continuación son lo que el cliente puede descargar ahora. La versión enviada y aún en análisis aparece destacada, separada de la que está publicada.",
    "Padrão: 30 minutos": "Predeterminado: 30 minutos",
    "Pangle App ID": "Pangle App ID",
    "Play Store (Android)": "Play Store (Android)",
    "Pontuação (fator por combustível)": "Puntuación (factor por combustible)",
    "Preços e Descontos": "Precios y Descuentos",
    "Processa os comentários não analisados desta rede usando IA": "Procesa los comentarios no analizados de esta red usando IA",
    "Prévia — nada foi gravado.": "Vista previa — no se guardó nada.",
    "Pular (não mexe na regra existente)": "Omitir (no modifica la regla existente)",
    "QrCode": "QrCode",
    "Quando a etiqueta já tem regra de pontuação": "Cuando la etiqueta ya tiene regla de puntuación",
    "Quando ativado, as vendas (abastecimentos) serão enviadas automaticamente para a Dotz, gerando Dotz ao invés de pontos na Pontuax.": "Cuando está activado, las ventas (cargas de combustible) se enviarán automáticamente a Dotz, generando Dotz en lugar de puntos en Pontuax.",
    "Quando ativado, habilita o uso das novas regras de pontuação (scorings) e exibe o menu de criação no admin.": "Cuando está activado, habilita el uso de las nuevas reglas de puntuación (scorings) y muestra el menú de creación en el panel.",
    "Quando ativado, o aplicativo obrigará o envio de localização e a proximidade do cliente ao posto para fazer o abastecimento lendo o QrCode.": "Cuando está activado, la aplicación exigirá el envío de la ubicación y la proximidad del cliente a la estación para realizar la carga de combustible leyendo el QrCode.",
    "Quando desativado, o endpoint de vendas externas não aceitará novas vendas para esta rede.": "Cuando está desactivado, el endpoint de ventas externas no aceptará nuevas ventas para esta red.",
    "Quando desativado, possibilitará que o cliente abasteça sem estar no posto por 15 minutos. Após esse prazo, essa opção ficará ativa novamente de forma automática.": "Cuando está desactivado, permitirá que el cliente cargue combustible sin estar en la estación durante 15 minutos. Después de ese plazo, esta opción se activará nuevamente de forma automática.",
    "Quando marcado, o bico deverá ser informado obrigatoriamente em formulários como o de adição de pontos.": "Cuando está marcado, el pico deberá informarse obligatoriamente en formularios como el de adición de puntos.",
    "Quando marcado, o encerrante deverá ser informado obrigatoriamente em formulários como o de adição de pontos.": "Cuando está marcado, el totalizador deberá informarse obligatoriamente en formularios como el de adición de puntos.",
    "Quando marcado, o usuário NÃO poderá dispensar a tela de atualização e será obrigado a atualizar o app. Quando desmarcado, o usuário pode escolher 'Deixar pra depois'.": "Cuando está marcado, el usuario NO podrá descartar la pantalla de actualización y estará obligado a actualizar la aplicación. Cuando está desmarcado, el usuario puede elegir 'Dejar para después'.",
    "Recarga Elétrica (InCharge)": "Recarga Eléctrica (InCharge)",
    "Redes": "Redes",
    "Revenda": "Revendedor",
    "Revendedores": "Revendedores",
    "SGA": "SGA",
    "Senha do Certificado": "Contraseña del Certificado",
    "Service Account": "Service Account",
    "Simular": "Simular",
    "Sociais": "Sociales",
    "Somente encher tanque": "Solo llenar tanque",
    "Telefone": "Teléfono",
    "Tempo máximo do abastecimento (minutos)": "Tiempo máximo de la carga de combustible (minutos)",
    "Tempo máximo, em minutos, para buscar os abastecimentos recentes do bico na tela de Adicionar Pontos por Abastecimento. Em branco, usa o padrão de 30 minutos.": "Tiempo máximo, en minutos, para buscar las cargas de combustible recientes del pico en la pantalla de Agregar Puntos por Carga de Combustible. En blanco, usa el valor predeterminado de 30 minutos.",
    "Twitter": "Twitter",
    "Usa Limites de Pontuação": "Usa Límites de Puntuación",
    "Usa Twilio": "Usa Twilio",
    "Usa código no frentista": "Usa código en el playero",
    "Usar QR Code na verificação de SignUp": "Usar QR Code en la verificación de SignUp",
    "Usar novas regras de pontuação": "Usar nuevas reglas de puntuación",
    "Usar odômetro de veículo": "Usar odómetro de vehículo",
    "Vendas Externas": "Ventas Externas",
    "Ver preço no app 🔒 requer desenvolvimento": "Ver precio en la aplicación 🔒 requiere desarrollo",
    "Verificação e Cadastro": "Verificación y Registro",
    "Versão nas lojas": "Versión en las tiendas",
    "Versão verificada.": "Versión verificada.",
    "Visualizar rede": "Ver red",
    "Youtube": "Youtube",
    "id": "id",
    "Última versão gerada:": "Última versión generada:",
};

export default catalogo;
